export default __webpack_public_path__ + "static/media/user-empty.7ba496dd.jpg";